export enum UserEvents {
    ActiveLocationChanged = 'user.activeLocationChanged'
}
